<template>
  <div am-edit-modal-item>
    <i-textarea
      ref="textarea"
      v-model="value" />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'FieldItem',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    heightArea: false
  }),
  computed: {
    value: {
      get () {
        return this.data.data
      },
      set (value) {
        this.$store.state.parts.data[this.$route.params.subtable].parts[this.data.index].data = value
        this.SET_CHANGED_PARTS({ subtable: this.$route.params.subtable, data: this.data })
      }
    }
  },
  methods: {
    ...mapMutations('parts', ['SET_CHANGED_PARTS'])
  }
}
</script>

<style lang="scss">
[am-edit-modal-item] {
  textarea {
    min-height: 2.5rem;
  }
  textarea:focus-visible {
    outline: none;
  }
}
</style>
